import LottoGameCard, { LottoGameCardProps } from '.'

interface LottoGameCardGridProps {
  items: LottoGameCardProps[]
}

const LottoGameCardGrid: React.FC<LottoGameCardGridProps> = ({ items }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4 w-full">
      {items.map((item) => (
        <div key={item.id}>
          <LottoGameCard {...item} />
        </div>
      ))}
    </div>
  )
}

export default LottoGameCardGrid
